import React from 'react'
import MetaTags from 'react-meta-tags';
import {Helmet} from "react-helmet";
import { Navbar, DB_Header, Contenido, Votar, Comentarios, Blogs_relacionados} from '../container';
import FooterPrime from '../container/Footer/Footer';
import '../App.css';

import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DetallesBlog = () => {
  const { friendly } = useParams();

  const [t, i18n] = useTranslation("global");
  const { data, isLoading, error } = useAxios(`/blogs/by-friendly/${ friendly }?lang=${ i18n.language }`);
  // const { data, isLoading, error } = useAxios(`/blogs/by-friendly/${ friendly }?lang=en`);
  const { titulo, categorias, fecha, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;


  const resumensplit = (txtresumen) => {
    // Verificar si txtresumen es una cadena y no es undefined
    if (typeof txtresumen === 'string' && txtresumen.trim() !== '') {
        // Realizar split por "||"
        const partes = txtresumen.split("||");

        // Verificar si hay una segunda parte
        if (partes.length > 1 && partes[0].trim() !== "") {
            return partes[0].trim(); // Si hay una segunda parte, retornarla
        }
    }
    return txtresumen;
  };

  console.log(error);
  return (
    <>
      {
      ( isLoading )
      ? ( <h1> Loading...</h1>)
      : (
        <div className='App_DB'>
          <MetaTags>
            <meta charset="utf-8" />
            <title>{titulo}</title>
            <meta name="description" content={resumensplit(resumen)} />
            <meta property="og:title" content={titulo}/>
            <meta property="og:description" content={resumensplit(resumen)}/>
            <meta property="og:url" content={"https://www.ricardosalinas.com/blog/"+tag} />
            <meta property="og:image" content={urlImagen} />
            <meta name="twitter:title" content={titulo} />
            <meta name="twitter:image" content={urlImagen} />
            <meta name="twitter:url" content={"https://www.ricardosalinas.com/blog/"+tag} />
          </MetaTags>
          <Navbar/>
            <DB_Header titulo={ titulo } categorias={ categorias } urlImagen={ urlImagen } fecha={ fecha } resumen={ resumen }/>
            <Contenido contenidoHtml={ contenidoHtml } titulo={ titulo }/>
            <Votar friendlyTag={friendly}/>
            <Comentarios comentarios={ comentarios } friendlyTag={ tag }  guid={ guid } titulo={ titulo } />
            <Blogs_relacionados blogsRelacionados={ blogsRelacionados } categorias={ categorias }/>
            <FooterPrime/>
        </div>
        )
      }
    </>
  )
}

export default DetallesBlog
